import React, {useState} from "react";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {renderTimeViewClock, TimeField as TimeFieldMUI} from "@mui/x-date-pickers";
interface Props {
  value: any;
  onChange: (value:any) => void;
}

export const TimeField: React.ComponentType<Props> = ({value, onChange}) => {

  const [open, setOpen] = useState(false);

  return (<>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <TimeFieldMUI
        slotProps={{
          textField: { size: 'small' }
      }}
        ampm={false}
        defaultValue={dayjs(value, 'HH:mm')}
        onChange={(newValue: any) => {
          const datetime = dayjs(newValue, 'HH:mm').format('HH:mm');
          if (datetime !== 'Invalid Date') {
            onChange(dayjs(newValue, 'HH:mm').format('HH:mm'));
          } else {
            onChange(null);
          }
        }}
        />
    </LocalizationProvider>
  </>);

}